import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from "react";
import { StyledModal, StyledModalHandle } from "@constants/Themed";
import GenerateSchemaForm from '@hooks/generateSchemaForm';
import apis from "@api/api";
import { View } from "react-native";

type AddDepartmentModalProps = {
  submitFunction?: (values: any) => void;
}

type AddDepartmentModalHandle = {
  openModal: (department: any) => void;
  closeModal: () => void;
}

const AddToDepartmentModal = forwardRef<AddDepartmentModalHandle, AddDepartmentModalProps>((props, ref) => {
  const { submitFunction } = props;
  const modalRef = useRef<StyledModalHandle>(null);
  const [selectedDepartment, setSelectedDepartment] = useState({
    _id: "",
    department_name: ""
  });

  useImperativeHandle(ref, () => ({
    openModal: (department) => {
      console.log(department, 'from within');
      setSelectedDepartment(department);
      modalRef.current?.openModal();
    },
    closeModal: () => {
      modalRef.current?.closeModal();
    },
  }));

  useEffect(() => {
    return () => {
      // Cleanup function to reset state when component unmounts
      setSelectedDepartment({
        _id: "",
        department_name: ""
      });
    };
  }, []);

  const submitAddDepartment = async (values) => {
    await apis.addUserToDepartment(values, selectedDepartment._id);
  }

  const addDepartment = {
    user: { validation: { required: true }, type: "team", ref: "team" },
  }

  return (
    <StyledModal
      modalRef={modalRef}
      ref={modalRef}
      animation={require("@assets/animations/1865-shooting-stars-outline-edited.json")}
      title={`Add User to ${selectedDepartment.department_name}`}
      caption="Adding a user to a department will allow them to inherit permissions"
    >
      <GenerateSchemaForm
        extraCallBack={() => modalRef.current?.closeModal()}
        Progress
        schema={addDepartment}
        nullify={[]}
        submitFunction={submitAddDepartment}
      />
    </StyledModal>
  );
});

export default AddToDepartmentModal;